import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mt-minus-16 mb-24" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form__set form__set--wrap" }
const _hoisted_4 = {
  key: 0,
  class: "form__error pre-wrap"
}
const _hoisted_5 = { class: "flex flex--wrap flex--gap-large flex--align-center" }
const _hoisted_6 = {
  class: "button button--fill button--small",
  type: "submit"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.show_form === false)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button button--small",
          type: "button",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.show_form = !$setup.show_form))
        }, " Create a new " + _toDisplayString($props.formTitle.toLowerCase()), 1 /* TEXT */))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _withModifiers($setup.clientUserForm, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode($setup["InputComponent"], {
              value: $setup.localised_form_fields.full_name,
              type: "text",
              "input-id": "full-name",
              name: "full-name",
              label: "Full Name",
              required: true,
              errors: $setup.localised_form_errors.full_name || null,
              "onUpdate:value": _cache[1] || (_cache[1] = new_value => $setup.localised_form_fields.full_name = new_value)
            }, null, 8 /* PROPS */, ["value", "errors"]),
            _createVNode($setup["InputComponent"], {
              value: $setup.localised_form_fields.email,
              type: "email",
              "input-id": "email",
              name: "email",
              label: "Email address",
              required: true,
              errors: $setup.localised_form_errors.email || null,
              "onUpdate:value": _cache[2] || (_cache[2] = new_value => $setup.localised_form_fields.email = new_value)
            }, null, 8 /* PROPS */, ["value", "errors"]),
            _createVNode($setup["InputComponent"], {
              value: $setup.localised_form_fields.role,
              type: "text",
              "input-id": "role",
              name: "role",
              label: "Role",
              "sub-label": "Optional",
              required: false,
              errors: $setup.localised_form_errors.role || null,
              "onUpdate:value": _cache[3] || (_cache[3] = new_value => $setup.localised_form_fields.role = new_value)
            }, null, 8 /* PROPS */, ["value", "errors"]),
            ($setup.client_user_form_errors)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.client_user_form_errors), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", _hoisted_6, " Add " + _toDisplayString($props.formTitle.toLowerCase()), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "a a--no-underline a--small",
                type: "button",
                onClick: _cache[4] || (_cache[4] = $event => ($setup.show_form = !$setup.show_form))
              }, " Cancel ")
            ])
          ])
        ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2))
  ]))
}